/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * Page Auth Service Access translation
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.11.0
 */

import { IPageAuthServiceAccessTranslation } from '../../types';

const initTranslationPageAuthServiceAccess: IPageAuthServiceAccessTranslation = {
    collapse: {
        body: '',
        title: '',
    },
    form: {
        buttonSubmit: '',
        captcha: '',
        labelLogin: '',
        labelPassword: '',
        passwordForget: '',
        subTitle: '',
        title: '',
    },
    notice: {
        captchaRequired: '',
        errorLoginForm: '',
        errorLoginUserForm: '',
        incorrectAnswer: '',
        passwordRecoverBoth: '',
        passwordRecoverMail: '',
        passwordRecoverPhone: '',
    },
    userForm: {
        buttonSubmit: '',
        labelLogin: '',
        subTitle: '',
        title: '',
    },
};

export default initTranslationPageAuthServiceAccess;
